import { IGetRemittanceParams, IRemittanceRepository, IRemittanceRepositoryResponse } from "@/core/repositories/remittance";

export class GetRemittanceUseCase {
  constructor(private readonly remittanceRepository: IRemittanceRepository) {}

  async execute(params: IGetRemittanceParams, refetch: boolean = false): Promise<IRemittanceRepositoryResponse> {
    return this.remittanceRepository.getRemittances(params, refetch);
  }
}
